
export const getCookie = (cname) => {
	let name = `${ cname }=`;
	let ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
};

export const setCookie = (cname, cvalue, expires, path = '/', configs = '') => {
	/* var d = new Date();
	var midnight = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59); // set hours to today's 11.59pm
	var expires = `expires=${ midnight.toUTCString()}`; */
	
	// configs-argument should be in string, for example: ";domain=example.com;secure;SameSite=Lax"
	document.cookie = `${ cname }=${ cvalue };expires=${ expires };path=${ path }${configs}`;
};


export const deleteCookie = (cname, configs = '') => {
	document.cookie = `${ cname }=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

	if (cname === 'sapphire') {
		document.cookie = `${ cname }=${ getCookie(cname) };domain=.malaysiaairlines.com;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
	}
	
	if (cname === 'sapphire-amal') {
		document.cookie = `${ cname }=;Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT${configs}`;
	}
};


const IR_COOKIE_NAME = 'irclickid';

export const getQueryParam = (name) => {
	const params = new URLSearchParams(window.location.search);
	return params.get(name);
};

export const handleImpactIrClickId = () => {
	const urlIrClickId = getQueryParam(IR_COOKIE_NAME);

	// Only act for Impact deeplinks
	if (!urlIrClickId) return;

	const expiryDate = new Date();
	expiryDate.setDate(expiryDate.getDate() + 7);

	setCookie(
		IR_COOKIE_NAME,
		urlIrClickId,
		expiryDate.toUTCString()
	);
};

